import {useRef, useEffect} from 'react';

function App(props) {


  var items = props.items;
  var style = props.style;
  var onClick = props.onClick;
  var nos = props.nos;
  var editRefs = props.editRefs;
  var setEditRefs = props.setEditRefs;

  const thisItemRef = useRef(null);

  useEffect(()=>{
    editRefs[nos] = thisItemRef;
    setEditRefs(editRefs);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return <div className='dropdownItemXX' ref={thisItemRef} onClick={onClick} style={style}>{items}
        </div>


}


//
export default App;
